export default __webpack_public_path__ + "static/media/BuildTeam.569caa3d.svg";